import { browserTracingIntegration, captureException, init } from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'
import { version } from '../../../../package.json'

const productionHost = 'qic.online'
const environment = location.host === productionHost ? 'production' : location.host
const ignoreList = [
  'Invalid time value', // ios safari false alarm
  'network_error', // TBA
  'Unexpected token', // TBA
  'roistat', // analytics
  'Move target is disabled', // ios safari false alarm
  'no_name_error', // just duplicate
  'chunk', // cache problem
  'Failed to fetch', // requests in analytics
  'getBattery', // requests in analytics
  'Navigation', // router
  'Load failed', // requests in analytics
  'prototype', // requests in analytics
  'Unexpected', // user's network
  '.replaceAll', // 3rd party lib error
  'frame', // requests in analytics
  'Illegal invocation', // requests in analytics
  'Page already has an active payment session', // apply pay
  'An attempt was made to break through the security policy of the user agent', // clickcease
]

const ignoreCrumbList = ['webvisor', 'analytics', 'roistat']
const allowUrls = [
  'https://qic.online',
  'https://qatar.qic-dev.online',
  'https://qatar.qic-uat.online',
]

const ignoreTransactions = [
  'https://px.ads.linkedin.com',
  'https://monitor.clickcease.com',
  /https:\/\/mc\.yandex\.(ru|com)/,
  'https://tr6.snapchat.com',
  'https://translate-pa.googleapis.com',
  'https://api.amplitude.com',
]

type SentryInitOptions = Parameters<typeof init>[0]

export const SentryLib = {
  init(app: App, router: Router) {
    const config: SentryInitOptions = {
      app,
      dsn: import.meta.env.VUE_APP_SENTRY_DSN,
      environment,
      allowUrls,
      ignoreTransactions,
      release: version,
      beforeSend: (body: any, hint: any) => {
        console.log(body)
        console.log(hint)
        const error = hint.originalException

        if (error && error.message) {
          const inIgnore = ignoreList.some((sentence) => error.message.indexOf(sentence) !== -1)

          if (inIgnore) {
            return null
          }
        }

        return body
      },
      beforeBreadcrumb(breadcrumb: any) {
        return ignoreCrumbList.some((sentence) => breadcrumb.message.indexOf(sentence) !== -1)
          ? null
          : breadcrumb
      },
    }

    if (import.meta.env.VUE_APP_ENV === 'PRODUCTION') {
      config.tracesSampleRate = 0.1
      config.integrations = [
        browserTracingIntegration({ router }),
      ]
    }

    init(config)
  },

  pushError(message: string) {
    const error = new Error(message)
    captureException(error)
  },
}
